import { BaseDosageChoice } from "@/service/models/common/query-dosage/dosage-choices";

export abstract class BaseDosageChoiceVM
{
    /**
     * Used by the UI to know if all data of the DosageChoice have been filled by the user.
     */
    public abstract isValid(): boolean;

    /**
     * Instantiate and returns a model populated with the data from the ViewModel object.
     * This function must return a model or throw an exception if some data are missing, in
     * this case the isValid() method should return false.
     */
    public abstract getModel(): BaseDosageChoice;

    /**
     * Populate the ViewModel instance with data from a model.
     * 
     * @param model         The model from which to take the data from
     */
    public abstract fillFromModel(model: BaseDosageChoice): BaseDosageChoiceVM;
}
